<template>
  <div>
    <div v-if="response && response.errors && response.errors.length" :class="errorClass">
      <div v-for="error in response.errors">
        {{ error }}
      </div>
    </div>

    <div v-if="response && response.message" :class="messageClass">
      {{ response.message }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'ResponseComponent',
  components: {},
  props: {
    response: Object,
    errorClass: String,
    messageClass: String,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
  }
};
</script>
